// extracted by mini-css-extract-plugin
export var btn_rounded = "ButtonTransparent-module--btn_rounded--2P34_";